import { ColumnDescription } from "react-bootstrap-table-next";
import Table from "../../../../../Components/Table";
import { IClienteDadosUau } from "../../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";

interface InfoTelefoneProps {
    clienteDados: IClienteDadosUau | undefined;
}

export default function InfoTelefone(props: InfoTelefoneProps) {
    const tableviewColumns: Array<ColumnDescription> = [
        {
            dataField: "ddd_tel",
            text: "DDD",
        },
        {
            dataField: "fone_tel",
            text: "Telefone",
        },

        {
            dataField: "tipo_tel",
            text: "Tipo",
        },
        {
            dataField: "ram_tel",
            text: "Complemento",
        },
    ];

    return (
        <div className="card-body bg-white rounded m-0 my-3 p-0 py-4">
            <Table
                columns={tableviewColumns}
                data={props?.clienteDados?.TELEFONES ?? []}
                keyField="ID_CLIENTE"
                noDataIndication={() => (
                    <div className="text-black-50 text-center">
                        Nenhum Telefone encontrado
                    </div>
                )}
                defaultStyle={{
                    align: "center",
                    classes: "p-4",
                }}
                noHover
                bordered={false}
                loading={false}
                noSearch
                totalPages={Math.ceil(
                    props?.clienteDados?.TELEFONES?.length ?? 0 / 10
                )}
                striped={true}
                rowClasses={"rowClasses"}
            />
        </div>
    );
}
